import { sortTemporadasByYearThenAlpha } from "../Meetings/meetingTemporadaSort";

/** Valor del select de proyecto: crear uno nuevo en Compás. */
export const NEW_COMPASS_PROJECT = "__new__";

function seasonLabel(row) {
  if (typeof row === "string") return String(row).trim();
  return String(row?.TEMPORADA || row?.Temporada || "").trim();
}

/**
 * Temporadas del diálogo: catálogo + las que ya tienen proyecto + la sugerida.
 * Año reciente primero.
 */
export function seasonLabelsForPdfSave({
  projects = [],
  catalog = [],
  suggested = "",
} = {}) {
  const labels = [];
  const push = (raw) => {
    const s = seasonLabel(raw);
    if (s && !labels.includes(s)) labels.push(s);
  };
  for (const row of catalog || []) push(row);
  for (const project of projects || []) push(project?.Temporada);
  push(suggested);
  return sortTemporadasByYearThenAlpha(labels);
}

/**
 * Alta de proyecto Compás desde el diálogo de PDF.
 * El cliente tiene que salir del catálogo (id + nombre).
 */
export function validateNewCompassProject({
  name = "",
  temporada = "",
  customer = null,
} = {}) {
  const projectName = String(name || "").trim();
  const season = String(temporada || "").trim();
  const customerId = Number(customer?.id);
  const customerName = String(customer?.label || "").trim();
  if (!season) return { ok: false, error: "season" };
  if (!customerName || !Number.isFinite(customerId) || customerId <= 0) {
    return { ok: false, error: "client" };
  }
  if (!projectName) return { ok: false, error: "name" };
  return {
    ok: true,
    body: {
      Name: projectName,
      Temporada: season,
      CustomerId: customerId,
      CustomerName: customerName,
    },
  };
}

/** Nombre inicial editable: cliente + temporada. */
export function defaultNewProjectName(customer, temporada) {
  return [String(customer?.label || "").trim(), String(temporada || "").trim()]
    .filter(Boolean)
    .join(" ");
}
